import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Expense } from '../../Types/HeyTraderTypes/Attendances/New/Expense';
import { getAttendanceExpenseList } from '../../Thunks/NewAttendanceThunks';

interface NewAttendanceExpenseSliceState {
  loader: boolean; // for refres pages and inital loadings
  attendanceExpenseList: Expense[];
  errorDisplay: string | null;
}

// set inital valus
const initialState: NewAttendanceExpenseSliceState = {
  loader: false,
  attendanceExpenseList: [],
  errorDisplay: '',
}

// set state valu for api response
const newAttendanceExpenseSlice = createSlice({
  name: 'newAttendanceExpenseSlice',
  initialState,
  reducers: {
  },
  extraReducers(builder) {
    builder
      .addCase(getAttendanceExpenseList.rejected, (state, action) => {
        state.loader = false;
        state.errorDisplay = action.error.message!;
      })

      .addCase(getAttendanceExpenseList.pending, state => {
        state.loader = true;
        state.errorDisplay = null;
      })

      .addCase(getAttendanceExpenseList.fulfilled, (state, action: PayloadAction<Expense[]>) => {
        state.loader = false;
        state.attendanceExpenseList = action.payload;
      })
  }
})

export const { } = newAttendanceExpenseSlice.actions
export default newAttendanceExpenseSlice.reducer
